import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import cosmosIcon from "@/assets/bronto-cosmos-logo.png";
import cosmosWordmark from "@/assets/bronto-cosmos-mark.png";
import biLogo from "@/assets/bronto-intelligence-logo-transparent.png";

export default function Footer() {
  return (
    <footer className="relative z-10 mt-24 border-t border-white/5 bg-black/40">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <img src={cosmosIcon} alt="" className="h-10 w-10 rounded-md object-contain" />
              <img src={cosmosWordmark} alt="Bronto Cosmos" className="h-7 w-auto object-contain" />
            </div>
            <p className="mt-5 text-sm text-white/55 max-w-sm leading-relaxed">
              A space, science, and astronomy discovery platform.
            </p>
            <p className="mt-4 text-sm text-white/55 max-w-sm leading-relaxed">
              Part of Bronto Intelligence Pvt. Ltd.
            </p>
            <div className="mt-6 flex flex-col items-start gap-3">
              <img
                src={biLogo}
                alt="Bronto Intelligence"
                className="h-6 w-auto opacity-90"
              />
              <a
                href="https://brontointelligence.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-parent-link"
                className="text-sm text-white/60 hover:text-white transition-colors inline-flex items-center gap-1.5"
              >
                Visit parent site
                <ExternalLink size={13} />
              </a>
            </div>
          </div>
          <div>
            <div className="eyebrow mb-4">Discover</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/today" className="text-white/70 hover:text-white">Space Today</Link></li>
              <li><Link to="/apod" className="text-white/70 hover:text-white">Astronomy Picture of the Day</Link></li>
              <li><Link to="/mars-rover" className="text-white/70 hover:text-white">Mars Rover Photos</Link></li>
              <li><Link to="/earth" className="text-white/70 hover:text-white">Earth From Space</Link></li>
              <li><Link to="/asteroids" className="text-white/70 hover:text-white">Asteroid Tracker</Link></li>
              <li><Link to="/gallery" className="text-white/70 hover:text-white">Space Gallery News</Link></li>
              <li><Link to="/planets" className="text-white/70 hover:text-white">Planet Facts</Link></li>
            </ul>
          </div>
          <div>
            <div className="eyebrow mb-4">Company</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="text-white/70 hover:text-white">About</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-white">Contact</Link></li>
              <li>
                <a href="https://brontointelligence.com/leadership" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white inline-flex items-center gap-1.5">
                  Leadership <ExternalLink size={12} />
                </a>
              </li>
              <li>
                <a href="https://brontointelligence.com/careers" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white inline-flex items-center gap-1.5">
                  Careers <ExternalLink size={12} />
                </a>
              </li>
              <li><Link to="/privacy" className="text-white/70 hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-white/70 hover:text-white">Terms of Use</Link></li>
            </ul>
          </div>
        </div>
        <div className="ad-slot mt-16" data-testid="ad-slot-footer" aria-hidden="true" />
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="text-xs text-white/45">
            © 2026 Bronto Intelligence Pvt. Ltd. All rights reserved.
          </div>
          <div className="text-xs text-white/45">
            Bronto Cosmos · Part of the Bronto Intelligence ecosystem.
          </div>
        </div>
      </div>
    </footer>
  );
}
